// ガイダンスの絞り込みで使う選択肢。学生アプリ(memorii)の「見つける」の絞り込みと同じ内容・順番にしている。
//   lib/1.recruit/3.searchModal/1.recruit.dart(タグ)、lib/1.recruit/2.parts/2.prefSearch.dart(都道府県と説明)、
//   lib/9.type/type8.dart(8タイプ)。アプリ側を変えたらここも合わせる。
// 画像はアプリの assets/map・assets/salon/circle を public/guidance/ にコピーしたもの。

export const PREFECTURES: { name: string; text: string }[] = [
  { name: "北海道", text: "広大な自然と海鮮・乳製品が有名な県" },
  { name: "青森県", text: "りんごが有名で、県民はりんご愛が強い" },
  { name: "岩手県", text: "広大な自然と岩手山、アウトドアも楽しめる" },
  { name: "宮城県", text: "牛タンと仙台の文化でグルメも観光も充実" },
  { name: "秋田県", text: "秋田美人で知られ、自然な艶髪が似合う" },
  { name: "山形県", text: "さくらんぼの産地、フルーツのツヤ感が自慢" },
  { name: "福島県", text: "桃や果物が豊富で、色鮮やかさが魅力" },
  { name: "茨城県", text: "納豆や自然が名物で、クセ強め文化もある" },
  { name: "栃木県", text: "日光東照宮の彫刻のように細やかで美しい" },
  { name: "群馬県", text: "温泉が豊富で、髪も心もリフレッシュできる" },
  { name: "埼玉県", text: "東京都に隣接し、便利さと落ち着きが両立" },
  { name: "千葉県", text: "ディズニーや海、明るく楽しい環境が魅力" },
  { name: "東京都", text: "美容トレンド発信地で最先端の情報が集まる" },
  { name: "神奈川県", text: "横浜夜景と湘南の海でヘアスタイルも映える" },
  { name: "山梨県", text: "ぶどうとワインが有名で、自然豊かな県" },
  { name: "長野県", text: "そばと山々に恵まれ、アウトドアが満喫できる" },
  { name: "新潟県", text: "金沢の金箔や伝統文化で華やかさがある" },
  { name: "富山県", text: "恐竜化石で有名、細やかな技術が光る県" },
  { name: "石川県", text: "加賀文化と海の幸が魅力で、美意識が高い県" },
  { name: "福井県", text: "そばと山の自然、ナチュラル系ヘアに合う" },
  { name: "岐阜県", text: "白川郷の合掌造り、守る技術が必要な町" },
  { name: "静岡県", text: "お茶と富士山、景観も美容意識も刺激される" },
  { name: "愛知県", text: "モーニング文化が豪華で、地元愛も強い" },
  { name: "三重県", text: "伊勢神宮が有名で、落ち着いた雰囲気の街" },
  { name: "滋賀県", text: "琵琶湖の景色が広がり、自然に癒される" },
  { name: "京都府", text: "和の美が溢れ、着物やヘアアレンジも映える" },
  { name: "大阪府", text: "食文化と笑いの街で、元気で明るい印象" },
  { name: "兵庫県", text: "神戸の港町でおしゃれなヘアスタイルが似合う" },
  { name: "奈良県", text: "鹿と歴史的建造物が多く、落ち着いた雰囲気" },
  { name: "和歌山県", text: "みかんや自然が豊かで、色彩豊かな県" },
  { name: "鳥取県", text: "砂丘や自然が広がり、ヘアも乱れやすい環境" },
  { name: "島根県", text: "出雲大社で縁結び、良縁を祈願できる県" },
  { name: "岡山県", text: "桃太郎伝説の地で、チーム力や元気が魅力" },
  { name: "広島県", text: "お好み焼き文化が強く、地元愛も厚い県" },
  { name: "山口県", text: "フグや海産物が有名で、繊細な技術も必要" },
  { name: "徳島県", text: "阿波おどりで動きのあるヘアアレンジが映える" },
  { name: "香川県", text: "うどん県、コシの強さは髪のコシにも活かせる" },
  { name: "愛媛県", text: "みかん産地、明るいカラーやイメージが似合う" },
  { name: "高知県", text: "坂本龍馬やカツオで大胆な県民性が特徴" },
  { name: "福岡県", text: "屋台ラーメンや夜の活気が楽しい街" },
  { name: "佐賀県", text: "有田焼の艶感のように髪も美しく見える" },
  { name: "長崎県", text: "ハウステンボスなど欧風景観で写真映え◎" },
  { name: "熊本県", text: "くまモンの可愛さと丸みのあるボブ感が魅力" },
  { name: "大分県", text: "温泉県で、髪も心もリフレッシュできる" },
  { name: "宮崎県", text: "マンゴーと南国ビーチが魅力の県" },
  { name: "鹿児島県", text: "桜島の迫力で、ヘアカラーも映える場所" },
  { name: "沖縄県", text: "海とエイサーで開放感いっぱい、リゾート気分" },
];

export const prefImage = (name: string) => `/guidance/map/${encodeURIComponent(name)}.png`;

export const SALON_TYPES: { name: string; image: string }[] = [
  { name: "有名サロン", image: "/guidance/type/1.png" },
  { name: "トレンドサロン", image: "/guidance/type/2.png" },
  { name: "おしゃれサロン", image: "/guidance/type/3.png" },
  { name: "ビューティーサロン", image: "/guidance/type/4.png" },
  { name: "オールラウンドサロン", image: "/guidance/type/5.png" },
  { name: "愛されサロン", image: "/guidance/type/6.png" },
  { name: "密着サロン", image: "/guidance/type/7.png" },
  { name: "こだわりサロン", image: "/guidance/type/8.png" },
];

export const TREATMENT_TAGS = ["カットが得意", "カラーが得意", "パーマが得意", "縮毛矯正が得意", "ヘアメイクが得意"];

export const STYLE_TAGS = ["かっこいい施術多め", "ナチュラルな施術多め", "トレンド感のある施術多め", "クリエイティブな施術多め", "エレガントな施術多め"];

export const BUSINESS_TAGS = ["理容", "美容", "メイク", "ネイル", "アイ", "ブライダル", "エステ", "その他", "兼任可能"];

export const BENEFIT_TAGS = [
  "社会保険完備", "ボーナス支給実績あり", "車・バイク出勤可", "寮・社宅あり",
  "住宅手当あり", "育児休暇あり", "国内就労ビザ取得支援あり（留学生向け）",
];

export const WORK_STYLE_TAGS = [
  "年間休日120日以上", "完全週休2日制", "残業月20時間以内", "20時までに退勤可能",
  "有給休暇消化率90%以上", "配属店舗の選択可", "時短勤務可",
];

export const EDUCATION_TAGS = [
  "デビューまで2年以内", "SNS研修あり", "自社アカデミーあり", "動画研修制度あり",
  "セミナー参加費補助", "ウィッグ代補助", "奨学金返済サポートあり", "営業中の練習OK",
  "資格取得支援", "社内コンテストあり", "複数の教育体制から選択可", "複数のキャリアプランを選択可",
  "独立・開業支援あり", "海外研修あり",
];

// 給与(月額)は 17万円(=未指定)〜25万円。アプリと同じ。
export const SALARY_MIN = 17;
export const SALARY_MAX = 25;

// 業種タグの色(アプリの求人一覧のリスト表示と同じ)
export const BUSINESS_TAG_COLORS: Record<string, string> = {
  理容: "#3695D9", 美容: "#E44E70", メイク: "#8B5CF6", ネイル: "#8B5CF6", アイ: "#8B5CF6",
  ブライダル: "#8B5CF6", エステ: "#8B5CF6", その他: "#6B6B6B", 兼任可能: "#6B6B6B",
};
